import type { RouteSwitchProps } from 'piral-core'
import type * as React from 'react'
import { Route, Switch } from 'react-router'

export const DefaultRouteSwitch: React.FC<RouteSwitchProps> = ({ paths, NotFound, ...props }) => {
  return (
    <Switch {...props}>
      {paths.map(({ path, Component }) => (
        <Route exact key={path} path={path} component={Component} />
      ))}
      <Route component={NotFound} />
    </Switch>
  )
}
DefaultRouteSwitch.displayName = 'DefaultRouteSwitch'
